import { put, call } from "redux-saga/effects";
import Axios from "../../utils/axios";
import {
  getBuyerIdentityError,
  getBuyerIdentityDone
} from "../../state/buyer-identity/actions";
import {
  NO_BUYER_IDENTITY_MESSAGE,
  SOMETHING_WENT_WRONG_MESSAGE
} from "../../constants";
import { showErrorSnackbar } from "../../utils/util";

function* getBuyerIdentity({ userId }) {
  try {
    const result = yield call(() =>
      Axios.core.get(`/buyer/stretchFanId/${userId}`)
    );
    const { data } = result;
    if (!data || !data.buyerId) {
      yield put(getBuyerIdentityError(NO_BUYER_IDENTITY_MESSAGE));
    } else {
      yield put(getBuyerIdentityDone(data));
    }
  } catch (e) {
    const errorMessage = JSON.parse(e.request.response).message;
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
    yield put(getBuyerIdentityError(SOMETHING_WENT_WRONG_MESSAGE));
  }
}

export default getBuyerIdentity;
